import { useI18n } from '../lib/i18n';
export interface StepDef {
  id: string;
  label: string;
}

interface Props {
  steps: StepDef[];
  current: string;
  /** Steps already completed may be revisited. */
  onJump?: (id: string) => void;
}

export function StepIndicator({ steps, current, onJump }: Props) {
  const { t } = useI18n();
  const currentIndex = steps.findIndex((s) => s.id === current);
  return (
    <ol className="steps" aria-label={t('booking.steps_label')}>
      {steps.map((s, i) => {
        const done = i < currentIndex;
        const active = i === currentIndex;
        const cls = `step${active ? ' is-active' : ''}${done ? ' is-done' : ''}`;
        return (
          <li key={s.id} className={cls} aria-current={active ? 'step' : undefined}>
            {done && onJump ? (
              <button type="button" className="step-btn" onClick={() => onJump(s.id)}>
                <span className="step-num" aria-hidden="true">{i + 1}</span>
                <span className="step-label">{s.label}</span>
              </button>
            ) : (
              <span className="step-btn">
                <span className="step-num" aria-hidden="true">{i + 1}</span>
                <span className="step-label">{s.label}</span>
              </span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
